import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IFAQ } from "../faqModel";

export const getAllFAQ = createAsyncThunk("FAQ/FindAllFAQ", async () => {
  try {
    const response = await axiosApiInstance.post(`${API_URL}/FAQ/FindAllFAQ`, {
      Question: "",
    });
    return response.data?.Data;
  } catch (error: any) {
    // ErrorToast(error?.response?.data?.Details || "Something went wrong");
    console.error("Error Fetching FAQ:", error);
    return Promise.reject({
      message: error?.response?.data?.Details || "Something went wrong",
    });
  }
});

export const createFAQ = createAsyncThunk(
  "FAQ/InsertFAQ",
  async (FAQData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/FAQ/InsertFAQ`,
        FAQData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating FAQ:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateFAQ = createAsyncThunk(
  "FAQ/UpdateFAQ",
  async (FAQData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/FAQ/UpdateFAQ`,
        FAQData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating FAQ :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteFAQ = createAsyncThunk(
  "FAQ/DeleteFAQ",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(`${API_URL}/FAQ/DeleteFAQ`, {
        ID,
      });
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting FAQ :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getFAQByID = createAsyncThunk(
  "FAQ/FindByIDFAQ",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/FAQ/FindByIDFAQ`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        ServicesID: result.ServicesID,
        ServiceName: result.ServiceName,
        Question: result.Question,
        Answer: result.Answer,
        SequenceNo: result.SequenceNo,
        IsActive: result.IsActive ? 1 : 2,
      } as IFAQ;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching FAQ :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveFAQ = createAsyncThunk(
  "FAQ/FindAllActiveFAQ",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/FAQ/FindAllActiveFAQ`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching FAQes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveFAQ = createAsyncThunk(
  "FAQ/ActiveInActiveFAQ",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/FAQ/ActiveInActiveFAQ`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive FAQ :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
